import { SET_FOR_YOU_QUESTIONS, IS_LOADING, SET_FOR_YOU_ERROR, SET_FOR_YOU_CONTENT, SET_ONBOARDING_COMPLETED } from "./constants";

const initialState = {
  questions: [],
  isLoading: true,
  error: null,
  dashboardContent: [],
  contentFetched: false,
  questionsFetched: false,
  onboardingCompleted: false,
};

function ForYouReducer(state = initialState, action) {
  switch (action.type) {
    case SET_FOR_YOU_QUESTIONS:
      return {
        ...state,
        questions: action.data,
        questionsFetched: true,
        error: null,
        // If questions array is empty, onboarding is completed
        onboardingCompleted: Array.isArray(action.data) && action.data.length === 0,
      };
    case SET_ONBOARDING_COMPLETED:
      return {
        ...state,
        onboardingCompleted: action.data,
      };
    case IS_LOADING:
      return {
        ...state,
        isLoading: action.data,
      };
    case SET_FOR_YOU_ERROR:
      return {
        ...state,
        error: action.data,
      };
    case SET_FOR_YOU_CONTENT:
      return {
        ...state,
        dashboardContent: action.data,
        contentFetched: true,
      };
    default:
      return state;
  }
}

export default ForYouReducer; 